import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import theme from '@ep/theme';

const FooterSocialLink = styled(Link)`
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  line-height: 3rem;
  color: ${theme.colors.white};
`;

export default FooterSocialLink;
